module.exports = __webpack_public_path__ + "static/img/ku-education.ee7b70c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing/ku-education.jpg
// module id = 2R1u
// module chunks = 0